/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetReportRunsCatalogArtifactUrlQueryResponse, AuditReportsGetReportRunsCatalogArtifactUrlPathParams, AuditReportsGetReportRunsCatalogArtifactUrl401, AuditReportsGetReportRunsCatalogArtifactUrl403, AuditReportsGetReportRunsCatalogArtifactUrl404 } from "../models/AuditReportsGetReportRunsCatalogArtifactUrl";

export function getAuditReportsGetReportRunsCatalogArtifactUrlUrl(id: AuditReportsGetReportRunsCatalogArtifactUrlPathParams["id"], kind: AuditReportsGetReportRunsCatalogArtifactUrlPathParams["kind"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/report-runs/${id}/artifacts/${kind}` as const }
  return res
}

/**
 * @description Returns a time-limited HTTPS `url` (default 1 hour). Requires artifacts[kind].storageUri to be set — poll GET /report-runs/{id} first. `kind` is e.g. package (primary) or xls (derived). Do not expose storageUri to end users.
 * @summary Get a signed download URL for an artifact
 * {@link /audit-reports/v1/report-runs/:id/artifacts/:kind}
 */
export async function auditReportsGetReportRunsCatalogArtifactUrl(id: AuditReportsGetReportRunsCatalogArtifactUrlPathParams["id"], kind: AuditReportsGetReportRunsCatalogArtifactUrlPathParams["kind"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetReportRunsCatalogArtifactUrlQueryResponse, ResponseErrorConfig<AuditReportsGetReportRunsCatalogArtifactUrl401 | AuditReportsGetReportRunsCatalogArtifactUrl403 | AuditReportsGetReportRunsCatalogArtifactUrl404>, unknown>({ method : "GET", url : getAuditReportsGetReportRunsCatalogArtifactUrlUrl(id, kind).url.toString(), ... requestConfig })
  return res.data
}